<section class="title-bar content-padding first-item">
  <div class="wrapper">
    <ng-template [ngIf]="selected == 'active'">
      <a routerLink="nuovo" *ngIf="groups.includes('admin') || groups.includes('partner')">
        <span class="btn btn-white right" id="addNewOfferBtn">Aggiungi<i class="ml-10 fas fa-plus"></i></span>
      </a>
    </ng-template>
    <h2>{{settings[selected].title}}</h2>
    <br class="clear">
  </div>
</section>

<section class="main-content wrapper content-padding">
  <div class="col-100 left">
    <!-- <h3>{{settings[selected].subtitle}}</h3> -->
    <div class="flex-container leggenda">
      <div class="item" *ngFor="let oSActive of offerStatusAux[selected]">
        <span class="status {{offerStatusAux.css(oSActive)}}"></span>
        {{offerStatusAux.ln('it', oSActive)}}
      </div>
    </div>
  </div>
  <br class="clear">

  <!--Custom built table-->
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)">
  </app-pagination>
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
    <form class="table-row-container row first-row filter" [formGroup]="_offerFilterForm" (ngSubmit)="filter()"
      *ngIf="_offerFilterForm">
      <div class="item data-col-{{getSpacing('id')}}">
        <h4 class="title" (click)="navigateOrder('Offer.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.id')"></i>
          ID</h4>
        <span class="data"></span>
      </div>
      <div class="item data-col-{{getSpacing('name')}}">
        <h4 class="title" (click)="navigateOrder('Offer.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.name')"></i>
          Titolo</h4>
        <span class="data">
          <input type="text" formControlName="Offer.name">
        </span>
      </div>
      <div class="item data-col-{{getSpacing('description')}}">
        <h4 class="title" (click)="navigateOrder('Offer.description')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.description')"></i>
          Descrizione</h4>
        <span class="data">
          <input type="text" formControlName="Offer.description">
        </span>
      </div>
      <div class="item data-col-{{getSpacing('products')}}">
        <h4 class="title" (click)="navigateOrder('Product.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Product.name')"></i>
          Prodotti</h4>
        <span class="data">
          <input type="text" formControlName="Product.name">
        </span>
      </div>
      <div class="item data-col-{{getSpacing('fromDate')}}">
        <h4 class="title" (click)="navigateOrder('Offer.fromDate')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.fromDate')"></i>
          Data pubblicazione</h4>
        <span class="data">
          <div class="date">Da: </div>
          <input class="date" type="date" formControlName="Offer.fromDate_from">
        </span>
        <span class="data">
          <div class="date">A: </div>
          <input class="date" type="date" formControlName="Offer.fromDate_to">
        </span>
      </div>
      <div class="item data-col-{{getSpacing('toDate')}}">
        <h4 class="title" (click)="navigateOrder('Offer.toDate')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.toDate')"></i>
          Data scadenza</h4>
        <span class="data">
          <div class="date">Da: </div>
          <input class="date" type="date" formControlName="Offer.toDate_from">
        </span>
        <span class="data">
          <div class="date">A: </div>
          <input class="date" type="date" formControlName="Offer.toDate_to">
        </span>
      </div>
      <div class="item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
        <h4 class="title" (click)="navigateOrder('Offer.status')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.status')"></i>
          Stato</h4>
        <span class="data">
          <select formControlName="Offer.status">
            <option value="">Tutti</option>
            <option *ngFor="let dSActive of offerStatusAux[selected]" [value]="dSActive">
              {{offerStatusAux.ln('it', dSActive)}}
            </option>
          </select>
        </span>
      </div>

      <div class="item">
        <h4 class="title">Azioni</h4>
        <span class="data">
          <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
            <i class="fas fa-search"></i></button>
        </span>
      </div>
      <hr class="hr-clear">
    </form>

    <div class="table-row-container row" *ngFor="let offer of offers">
      <div class="item data-col-{{getSpacing('id')}}">
        <h4 class="title" (click)="navigateOrder('Offer.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.id')"></i>
          ID</h4>
        <span class="data data-id">
          <a [routerLink]="offer.id">
            {{offer.id}}
          </a></span>
      </div>
      <div class="item data-col-{{getSpacing('name')}}">
        <h4 class="title" (click)="navigateOrder('Offer.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.name')"></i>
          Titolo</h4>
        <span class="data">
          <a [routerLink]="offer.id">
            {{offer.name}}
          </a></span>
      </div>
      <div class="item data-col-{{getSpacing('description')}}">
        <h4 class="title" (click)="navigateOrder('Offer.description')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.description')"></i>
          Descrizione</h4>
        <span class="data">
          <a [routerLink]="offer.id">
            {{offer.description}}
          </a></span>
      </div>
      <div class="item data-col-{{getSpacing('products')}}">
        <h4 class="title" (click)="navigateOrder('Product.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Product.name')"></i>
          Prodotti</h4>
        <span class="data">
          <a [routerLink]="offer.id">
            {{offer.products | arrayJoin:', ':'name'}}
          </a></span>
      </div>
      <div class="item data-col-{{getSpacing('fromDate')}}">
        <h4 class="title" (click)="navigateOrder('Offer.fromDate')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.fromDate')"></i>
          Data pubblicazione</h4>
        <span class="data">
          <a [routerLink]="offer.id">
            {{offer.fromDate | date:'dd/MM/yyyy'}}
          </a></span>
      </div>
      <div class="item data-col-{{getSpacing('toDate')}}">
        <h4 class="title" (click)="navigateOrder('Offer.toDate')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.toDate')"></i>
          Data scadenza</h4>
        <span class="data">
          <a [routerLink]="offer.id">
            {{offer.toDate | date:'dd/MM/yyyy'}}
          </a></span>
      </div>
      <div class="item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
        <h4 class="title" (click)="navigateOrder('Offer.status')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Offer.status')"></i>
          Stato</h4>
        <span class="data">
          <a [routerLink]="offer.id">
            <span class="status {{offerStatusAux.css(offer.status)}}"
              [matTooltip]="offerStatusAux.ln('it', offer.status)"></span>
          </a></span>
      </div>
      <ng-template [ngIf]="selected == 'active'">
        <div class="item has-button has-margin-top data-col-{{getSpacing('edit')}}">
          <h4 class="center title hide-small">Azioni</h4>
          <span class="data has-button ml-5">
            <a [routerLink]="offer.id">
              <button class="btn">Modifica</button>
            </a>
          </span>
          <span class="data has-button ml-5" *ngIf="selected == 'active' && offer.status === offerStatus.unpublished">
            <button class="btn center" (click)="publish(offer.id)">
              Pubblica<i class="ml-10 fas fa-paper-plane"></i>
            </button>
          </span>
          <span class="data has-button ml-5" *ngIf="selected == 'active' && offer.status === offerStatus.published">
            <button class="btn center" (click)="finish(offer.id)">
              Termina<i class="ml-10 fas fa-flag-checkered"></i>
            </button>
          </span>
          <span class="data has-button ml-5">
            <button class="btn btn-red center" (click)="delete(offer.id)">
              Elimina<i class="ml-10 far fa-trash-alt"></i>
            </button>
          </span>
        </div>
      </ng-template>
      <hr class="hr-clear">
    </div>
  </div>
  <!--/Custom built table-->

</section>
